//-------------------------------------------------------------------------------------------------- Imports
import {
    DesktopOutlined,
    LaptopOutlined,
    MobileOutlined,
    TabletOutlined,
} from "@ant-design/icons";
import { InternetSeguroDevice } from "../../types/common";

//-------------------------------------------------------------------------------------------------- Helpers
export const getDeviceIcon = (device: InternetSeguroDevice) => {
    const haystack =
        `${device.model} ${device.name} ${device.manufacturer} ${device.osVersion} ${device.clientVersion}`.toLowerCase();
    if (
        haystack.includes("iphone") ||
        haystack.includes("phone") ||
        haystack.includes("mobile") ||
        haystack.includes("android")
    ) {
        return MobileOutlined;
    }
    if (haystack.includes("ipad") || haystack.includes("tablet")) {
        return TabletOutlined;
    }
    if (
        haystack.includes("macbook") ||
        haystack.includes("laptop") ||
        haystack.includes("notebook") ||
        haystack.includes("windows")
    ) {
        return LaptopOutlined;
    }
    return DesktopOutlined;
};